import React from 'react';
import { X, StickyNote } from 'lucide-react';

export function PracticeNoteModal({ noteModal, language, onClose, onSave }) {
  if (!noteModal) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" onClick={onClose} data-testid="practice-note-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
            <StickyNote className="text-yellow-500" size={20} />
            {language === 'es' ? 'Nota del Día' : 'Day Note'}
          </h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg transition-colors">
            <X size={20} className="text-gray-400" />
          </button>
        </div>
        <p className="text-sm text-gray-500 mb-4">
          {language === 'es'
            ? 'Agrega una nota para recordar qué pasó este día (opcional)'
            : 'Add a note to remember what happened this day (optional)'}
        </p>
        <textarea
          autoFocus
          defaultValue={noteModal.currentNote}
          placeholder={language === 'es' ? 'Escribe tu nota aquí...' : 'Write your note here...'}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          rows={4}
          data-testid="practice-note-textarea"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && e.ctrlKey) {
              onSave(noteModal.dateKey, e.target.value);
            }
          }}
        />
        <div className="flex gap-2 mt-4">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold rounded-lg transition-colors"
          >
            {language === 'es' ? 'Cancelar' : 'Cancel'}
          </button>
          <button
            onClick={(e) => {
              const textarea = e.target.closest('.bg-white').querySelector('textarea');
              onSave(noteModal.dateKey, textarea.value);
            }}
            className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-colors"
            data-testid="practice-note-save-btn"
          >
            {language === 'es' ? 'Guardar' : 'Save'}
          </button>
        </div>
        <p className="text-xs text-gray-400 mt-2 text-center">
          {language === 'es' ? 'Presiona Ctrl+Enter para guardar rápido' : 'Press Ctrl+Enter to save quickly'}
        </p>
      </div>
    </div>
  );
}

export function PracticeHoverNote({ hoverNote }) {
  if (!hoverNote) return null;
  return (
    <div className="fixed z-50 pointer-events-none" style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
      <div className="bg-yellow-50 border-2 border-yellow-300 rounded-lg shadow-xl p-3 max-w-xs">
        <div className="flex items-start gap-2">
          <StickyNote className="text-yellow-600 flex-shrink-0 mt-0.5" size={16} />
          <p className="text-sm text-gray-800 whitespace-pre-wrap">{hoverNote.note}</p>
        </div>
      </div>
    </div>
  );
}
